import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgEdit = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 16.9999H19V18.9999H3V16.9999ZM13.9749 5.81793L7.90381 11.889V13.3032H9.31802L15.3891 7.23214L13.9749 5.81793ZM18.2175 7.23214L10.1464 15.3032H5.90381V11.0606L13.9749 2.9895L18.2175 7.23214Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgEdit);

export default ForwardRef;
